import { observable, action, runInAction } from 'mobx';
import { isEmpty, cloneDeep } from 'lodash';

import moStore, { toggleValue } from '@store/index';
import moUser from '@store/user';
import moLogin, { toggleLogin } from '@store/login';
import localforage from 'localforage';

const moTime = observable({
  timeTabActive: '多指标',
  timeYearActive: '2018',
  timeActiveShow: 'chart',
  timeList: <any>{},
});

// 修改tab
const changeTab = action(async (val: string) => {
  runInAction(() => {
    moTime.timeTabActive = val;
  });
  const humanData: any = await localforage.getItem('humans') || {};
  humanData.momenttab = val;
  localforage.setItem('humans', humanData);
});

// 修改默认tab
const changeMomentTab = action(async (val: string) => {
  runInAction(() => {
    moTime.timeTabActive = val;
  });
});

// 修改时间tab
const changeTimeTab = action(async (val: string) => {
  runInAction(() => {
    moTime.timeYearActive = val;
  });
  const humanData: any = await localforage.getItem('humans') || {};
  humanData.moment = val;
  localforage.setItem('humans', humanData);
});

// 默认数据

const getHumanEfficiencyTime = action(async (val: number) => {
  runInAction(() => {
    moTime.timeList = val;
  });
});

// 展示表格还是图表

const changeShow = action(async (val: string) => {
  runInAction(() => {
    moTime.timeActiveShow = val;
  });
  const humanData: any = await localforage.getItem('humans') || {};
  humanData.momenttable = val;
  localforage.setItem('humans', humanData);
});

// 展示默认表格还是图表

const changeMomentShow = action(async (val: string) => {
  runInAction(() => {
    moTime.timeActiveShow = val;
  });
});


export default moTime;
export {
  changeTab, changeTimeTab, changeShow, getHumanEfficiencyTime, changeMomentShow,
  changeMomentTab,
};
